<script>
import { mapState } from 'vuex'
import Request from '@src/mixins/request'

export default {
  metaInfo: {
    title: 'Redeem',
    meta: [{ name: 'description', content: 'Redeem' }],
  },

  mixins: [Request],

  data() {
    return {
      voucherId: null,
      voucher: null,
      confirmDialog: false,
      color: 'gold',
    }
  },

  computed: {
    ...mapState('app', ['currentProperty']),
  },

  methods: {
    onSubmit() {
      this.voucher = null
      this.fetchData({
        url: this.endpoint.voucher.get,
        data: {
          id: this.voucherId,
          property: this.currentProperty.id,
        },
      })
        .then((data) => {
          this.voucher = data
        })
        .catch(() => {})
    },
    useVoucher() {
      this.updateData({
        url: this.endpoint.voucher.use,
        data: {
          id: this.voucherId,
          property: this.currentProperty.id,
        },
      })
        .then(() => {
          this.confirmDialog = false
          this.onSubmit()
        })
        .catch(() => {})
    },
  },
}
</script>

<template>
  <BaseView title="Reedem Voucher" :color="color">
    <!-- Toolbar Extension -->
    <VContainer slot="toolbar-extension" class="px-0" grid-list-xl>
      <VForm @submit.prevent="onSubmit">
        <VLayout row wrap>
          <VFlex xs8 sm3>
            <BaseControlInput label="ID">
              <VTextField
                v-model.number="voucherId"
                label="ID"
                :color="color"
              />
            </BaseControlInput>
          </VFlex>

          <VFlex xs4 sm3>
            <VBtn
              :color="color"
              :loading="loading"
              type="submit"
              dark
              depressed
            >
              Search
            </VBtn>
          </VFlex>
        </VLayout>
      </VForm>
    </VContainer>
    <!-- End of Toolbar Extension -->

    <div v-if="voucher && !loading">
      <BaseDisplayText label="ID" :text="voucher.id" />
      <BaseDisplayText label="Status" :text="voucher.status" />
      <BaseDisplayText label="Name" :text="voucher.name" />
      <BaseDisplayText label="Description" :text="voucher.description" />
      <BaseDisplayText label="Point" :text="voucher.point" />
      <BaseDisplayText label="Validity" :text="voucher.validity" />
      <BaseDisplayText label="Redeemed at" :text="voucher.redeemedAt" />
      <BaseDisplayText label="Used at" :text="voucher.usedAt" />
      <VBtn
        :color="color"
        :disabled="!voucher.canBeUsed"
        :dark="voucher.canBeUsed"
        depressed
        @click="confirmDialog = true"
      >
        Use Voucher
      </VBtn>
    </div>

    <VDialog v-model="confirmDialog" max-width="290px" persistent>
      <VCard>
        <VCardTitle class="headline">Use voucher</VCardTitle>

        <VCardText>Are you sure want to use this voucher?</VCardText>

        <VCardActions>
          <VSpacer />
          <VBtn color="grey" flat @click="confirmDialog = false">
            Cancel
          </VBtn>

          <VBtn :color="color" flat @click="useVoucher">
            Use
          </VBtn>
        </VCardActions>
      </VCard>
    </VDialog>
  </BaseView>
</template>
